import AgenciesSecuritiesPercentagePopup from './AgenciesSecuritiesPercentagePopup';

export default AgenciesSecuritiesPercentagePopup;
